(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nobo-anchor"] && !Shopify.designMode) return;
  try {
    (() => {
    if (document.documentElement.classList.contains('shopify-design-mode')) return;
    const place = () => {
      document.querySelectorAll('.nobo-anchor').forEach((anchor) => {
        const section = anchor.closest('.shopify-section');
        if (section && section.firstElementChild !== anchor) section.prepend(anchor);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', place, { once: true });
    } else {
      place();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nobo-whatsapp-order"] && !Shopify.designMode) return;
  try {
    (() => {
    /** Construit le lien WhatsApp à partir de la variante actuellement choisie. */
    const buildUrl = (link) => {
      const scope = link.closest('.shopify-section') || document;
      const data = link.dataset;

      const variantInput = scope.querySelector('form[action*="/cart/add"] [name="id"]');
      const variantId = variantInput ? variantInput.value : '';

      const options = [];
      scope.querySelectorAll('variant-picker fieldset').forEach((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        if (checked) options.push(checked.value);
      });
      scope.querySelectorAll('variant-picker select').forEach((select) => {
        if (select.value) options.push(select.selectedOptions[0]?.textContent.trim() || select.value);
      });

      const quantityInput = scope.querySelector('input[name="quantity"]');
      const quantity = quantityInput ? quantityInput.value : '1';

      const priceElement = scope.querySelector('[ref="priceContainer"] .price bdi');
      const price = priceElement ? priceElement.textContent.trim() : '';

      const url = variantId ? `${data.url}?variant=${variantId}` : data.url;
      const lines = [
        data.intro,
        `• ${data.labelProduct}: ${data.title}`,
        options.length ? `• ${data.labelOptions}: ${options.join(' / ')}` : null,
        `• ${data.labelQuantity}: ${quantity}`,
        price ? `• ${data.labelPrice}: ${price}` : null,
        url,
        '',
        data.outro,
      ].filter((line) => line !== null);

      return `https://wa.me/${data.number}?text=${encodeURIComponent(lines.join(String.fromCharCode(10)))}`;
    };

    const refresh = (scope) => {
      scope.querySelectorAll('[data-nobo-wa-order]').forEach((link) => {
        link.href = buildUrl(link);
      });
    };

    // Au clic : toujours le message le plus à jour.
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-nobo-wa-order]');
      if (!link) return;
      link.href = buildUrl(link);
    });

    // Changement de couleur, de taille ou de quantité : on met aussi à jour le lien
    // (utile pour l’appui long / « ouvrir dans un nouvel onglet »). La variante est
    // mise à jour de façon asynchrone par le thème, d’où les deux relectures.
    document.addEventListener('change', (event) => {
      const scope = event.target.closest('.shopify-section');
      if (!scope || !scope.querySelector('[data-nobo-wa-order]')) return;
      refresh(scope);
      setTimeout(() => refresh(scope), 400);
      setTimeout(() => refresh(scope), 1200);
    });

    document.querySelectorAll('.shopify-section').forEach((scope) => {
      if (scope.querySelector('[data-nobo-wa-order]')) refresh(scope);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
